export const DEFAULTS = {
  step1: { producer: "", agentEmail: "", policyDate: undefined, carrier: [], powerUnits: undefined, personalUseOfTrailer: false, personalUseOfVehicle: false, },
  step2: {
    garagingSameAsMailing: false,
    motorCarrierNumber: undefined,
    primaryContactTitle: "",
    ownershipChangeLast12Months: false,
    dotSafetyRating: undefined,
  },
  step3: {
    operatingStart: undefined,
    opsTowingRep: undefined,
    corgiTravelDistance: undefined,
    corgiPassengerOperations: false,
    corgiFreightForwarder: false,
    corgiTransitMixerOperations: false,
    corgiDeliveryCourierOperations: false,
    corgiArmoredVehicles: false,
    corgiMostRunsUnder100Miles: false,
    corgiAutoRemoved: false,
  },
  step5: {
    drivers: [],
    driversDotCompliant: true,
  },
  step6: {
    vehicles: [],
    vehicleFilesDotCompliant: true,
    nbrOfTrucks: 0,
    valueOfTrucks: 0,
  },
  step7: {
    carrier: [],
    trailers: [],
    nbrOfTrailers: 0,
    valueOfTrailers: 0,
  },
  step8: {
    auto_liability: false,
    auto_liability_limit: undefined,
    personal_injury_protection: false,
    uninsured_motorists_property_damage: false,

    trailer_interchange: false,
    trailer_interchange_limit: undefined,

    motor_truck_cargo: false,
    motor_truck_cargo_limit: undefined,

    automobile_physical_damage: false,
    truckers_general_liability: false,
    non_trucking_liability: false,
    corgiMedicalPayments: false,
    corgiTriaCoverage: false,
    corgiUmUimCoverage: false,
    corgiTowTrucks: false,

    limits: {
      waiverSubrogation: false,
      primaryNoncontribTGL: false,
      primaryNoncontribAL: false,
      towingLimit: "unselected",
    },

    commodity_array: [],

    radius0_50: undefined,
    radius51_200: undefined,
    radius201_500: undefined,
    radius501: undefined,
    stateOperation: undefined,
    annualMileage: undefined,
  },
  step9: {
    losses: [
      {
        autoLiability: { count: 0, paid: 0 },
        physicalDamage: { count: 0, paid: 0 },
        cargo: { count: 0, paid: 0 },
        tgl: { count: 0, paid: 0 },
      },
      {
        autoLiability: { count: 0, paid: 0 },
        physicalDamage: { count: 0, paid: 0 },
        cargo: { count: 0, paid: 0 },
        tgl: { count: 0, paid: 0 },
      },
      {
        autoLiability: { count: 0, paid: 0 },
        physicalDamage: { count: 0, paid: 0 },
        cargo: { count: 0, paid: 0 },
        tgl: { count: 0, paid: 0 },
      },
    ],
  },
  step10: {
    documents: [],
    targetPricePerTruck: "",
  },
};
